import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import { StyledAppInstanceBadgeDropdownWrapper, StyledAppInstanceBadgeDropdown } from './ApplicationSwitcher.styles.js';
import { useDropdownMenu } from '@lwt-helix/useDropdownMenu';
import { NavbarContext } from './NavbarContext.js';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import ApplicationSwitcherAppInstanceDropdown$1 from './ApplicationSwitcherAppInstanceDropdownMenu.js';

/* eslint-disable max-len */
const ApplicationSwitcherAppInstanceDropdown = ({ item, getAppItems, menuRef, setHighlightedIndex, highlightedIndex, usePortal = false }) => {
    const { isOpen: isOpenInstance, getToggleButtonProps, getMenuProps, highlightedIndex: highlightedIndexMenu, getItemProps: getItemPropsMenu, setReferenceElement, setPopperElement, attributes, styles } = useDropdownMenu({
        placement: 'bottom-end',
        items: item.appInstances ? item.appInstances : [],
        itemToString: (item) => (item.label ? item.label : ''),
        offset: [0, 8],
        loopItemsOnKeyDown: false,
        closeMenuOnLastItem: true,
        closeMenuOnFirstItem: true,
        resetSelectedItemOnClose: true
    });
    const itemIndex = getAppItems ? getAppItems().indexOf(item) : -1;
    const { setAppInstancesOpen } = useContext(NavbarContext);
    const getDropdownLabel = () => {
        if (item.appInstances && item.appInstances.length > 0) {
            // return the first app instance label that is the default Option
            const defaultAppInstance = item.appInstances.find((appInstance) => appInstance.defaultOption);
            if (defaultAppInstance) {
                return defaultAppInstance.label;
            }
            else {
                return item.appInstances[0].label;
            }
        }
    };
    return (React.createElement(StyledAppInstanceBadgeDropdownWrapper, { ref: setReferenceElement },
        React.createElement(StyledAppInstanceBadgeDropdown, Object.assign({ className: 'helix-app-switcher__item-badge-dropdown', tabIndex: -1 }, getToggleButtonProps({
            onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                setAppInstancesOpen((instanceOpen) => {
                    // if instanceOpen includes item index remove it else add it
                    if (instanceOpen && instanceOpen.includes(itemIndex)) {
                        return instanceOpen.filter((index) => index !== itemIndex);
                    }
                    else {
                        return [...instanceOpen, itemIndex];
                    }
                });
            },
            onKeyDown: (e) => {
                if (e.key === 'Enter' || e.key === 'ArrowDown') {
                    e.preventDefault();
                    e.stopPropagation();
                    setAppInstancesOpen((instanceOpen) => {
                        // if instanceOpen includes item index remove it
                        // else add it
                        if (instanceOpen && instanceOpen.includes(itemIndex) && !isOpenInstance) {
                            return [];
                        }
                        else {
                            if (instanceOpen && !instanceOpen.includes(itemIndex)) {
                                return [...instanceOpen, itemIndex];
                            }
                        }
                    });
                }
            }
        }, { suppressRefError: true })),
            getDropdownLabel(),
            React.createElement(NavbarHelixIcon, { iconName: 'dropdown_open' })),
        usePortal ? (ReactDOM.createPortal(React.createElement(ApplicationSwitcherAppInstanceDropdown$1, { setPopperElement: setPopperElement, isOpenInstance: isOpenInstance, getMenuProps: getMenuProps, highlightedIndexMenu: highlightedIndexMenu, getItemPropsMenu: getItemPropsMenu, item: item, menuRef: menuRef, setHighlightedIndex: setHighlightedIndex, highlightedIndex: highlightedIndex, attributes: attributes, styles: styles, setAppInstancesOpen: setAppInstancesOpen }), document.body)) : (React.createElement(ApplicationSwitcherAppInstanceDropdown$1, { setPopperElement: setPopperElement, isOpenInstance: isOpenInstance, getMenuProps: getMenuProps, highlightedIndexMenu: highlightedIndexMenu, getItemPropsMenu: getItemPropsMenu, item: item, menuRef: menuRef, setHighlightedIndex: setHighlightedIndex, highlightedIndex: highlightedIndex, attributes: attributes, styles: styles, setAppInstancesOpen: setAppInstancesOpen }))));
};
ApplicationSwitcherAppInstanceDropdown.displayName = 'ApplicationSwitcherAppInstanceDropdown';

export { ApplicationSwitcherAppInstanceDropdown as default };
//# sourceMappingURL=ApplicationSwitcherAppInstanceDropdown.js.map
